import React from "react";

const LinkedIn = props => (
  <svg viewBox="0 0 16.7 15.34" {...props}>
    <title>linked-in</title>
    <g>
      <path
        d="M3.68 15.34H.42V4.92h3.26zM2 3.62a1.81 1.81 0 0 1-2-1.81A1.83 1.83 0 0 1 2 0a1.81 1.81 0 1 1 0 3.62zm14.7 11.72H13V9.95c0-1.41-.58-2.37-1.85-2.37A1.86 1.86 0 0 0 9.4 8.85a2.4 2.4 0 0 0-.08.85v5.64H5.66V4.92h3.66v1.63a3.34 3.34 0 0 1 3.25-1.74c2.31 0 4.13 1.5 4.13 4.73z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default LinkedIn;



// WEBPACK FOOTER //
// ./src/icons/LinkedIn.js